import { UserPlus } from 'lucide-react';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../../../api/adminDataProvider';
import { CustomBulkAction } from '../../Moonstar/CustomBulkAction';

export const BulkAddUserGroupMembers = (props: { groupId: number }) => {
  const dataProvider = useDataProvider<AdminDataProvider>();

  return (
    <CustomBulkAction
      mutationFn={(userIds) =>
        dataProvider.addUserGroupMembers({
          data: userIds.map((userId) => ({
            groupId: props.groupId,
            userId,
          })),
        })
      }
      label="ra.action.add"
      buttonIcon={<UserPlus />}
      successMessage="moonstar.user-group-members.add.successMessage"
    />
  );
};
